import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-tutorial-mfa',
  templateUrl: './tutorial-mfa.component.html',
  styleUrls: ['./tutorial-mfa.component.scss']
})
export class TutorialMfaComponent {
  public showGoogle: boolean = true;

  constructor(private readonly route: ActivatedRoute,
    private readonly titleService: Title) {}

  ngOnInit(): void {
    this.titleService.setTitle(this.route.snapshot.data['title']);
  }

  onTabChange(event: any): void {
    this.showGoogle = event.tab.textLabel === 'Google Authenticator';
  }

}
